import React, { createContext, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import localForage from 'localforage';

localForage.config({
	name: 'precrm-ui',
	version: 1.0,
	storeName: 'local_db',
});

const LocalDB = createContext({});

export const LocalDBProvider = ({ children }) => {
	const [value, setValue] = useState({});

	// initial data
	useEffect(() => {
		localForage.keys().then((keys) => {
			return keys.map((key) => {
				localForage.getItem(key).then((_value) => {
					setValue({
						...value,
						[key]: _value,
					});
				});
			});
		});
	}, []);

	const setItem = (key, _value) => {
		localForage.setItem(key, _value).then(function () {
			setValue({
				...value,
				[key]: _value,
			});
		});
	};

	return (
		<LocalDB.Provider
			value={{
				value,
				setItem,
			}}
		>
			{children}
		</LocalDB.Provider>
	);
};

LocalDBProvider.propTypes = {
	children: PropTypes.any.isRequired,
};

export const useLocalDB = () => {
	return useContext(LocalDB);
};